import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
} from "@material-ui/core";
import {
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";

import { useForm } from "../../../hooks/useForm";

import {
  getTiposRecetas,
  postReceta,
  setReceta,
  setActiveStep,
  setShowForm,
  getSubtiposRecetas
} from "../../../actions/recetasDigitales/RecetasDigitales";

import {
  OBRAS_SOCIALES,
  STEPPER_RECETAS, TIPOS_RECETAS
} from "../../../utils/constants";
import "moment/locale/es";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import {
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { ModalAlertaFecha } from "./ModalAlertaFecha";
import moment from "moment";
import { startAlerta } from "../../../actions/ui/alertas";

export const RecetasDigitalesDetalleTipoForm = (props) => {
  const dispatch = useDispatch();
  const [openModalAlertaFecha, setOpenModalAlertaFecha] = useState(false);

  const {
    afiliadoSeleccionado = {},
    recetaSeleccionada = {},
    tipoRecetasDigitales = [],
    subtipoRecetasDigitales = []
  } = useSelector((state) => state.recetasDigitales);

  console.log(recetaSeleccionada);

  let recetaDefault = {
    idAfiliado: "",
    idDiagnostico: "",
    idRecetaDigital: "",
    idTipoReceta: "",
    idSubtipoReceta: "",
    idUsuario: "",
    tipoReceta: "",
    fecha: new Date(),
    tratamientoProlongado: false
  };

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(
    !!recetaSeleccionada ? recetaSeleccionada : recetaDefault
  );

  const {
    idTipoReceta,
    fecha,
    idSubtipoReceta,
    tratamientoProlongado,
    duplicada,
  } = formValues;


  useEffect(() => {
    dispatch(getTiposRecetas());
    dispatch(getSubtiposRecetas());
  }, [dispatch]);

  const onSubmitHandler = () => {
    if (moment(fecha) < moment(new Date())
      && moment(fecha).format("DD-MM-YYYY") !== moment(new Date()).format("DD-MM-YYYY")) {
      dispatch(
        startAlerta(
          "La Fecha no puede ser anterior a hoy",
          "error",
          "Verificar Fecha"
        )
      );
    } else {
      if (recetaSeleccionada?.clonada && moment(fecha).format("DD-MM-YYYY") === moment(new Date()).format("DD-MM-YYYY")) {
        setOpenModalAlertaFecha(true);
      } else {
        const data = {
          ...recetaSeleccionada,
          idAfiliado: props.idObraSocial === OBRAS_SOCIALES.OSPEDYC ? afiliadoSeleccionado?.id_afiliado : null,
          idTipoReceta,
          fecha,
          idSubtipoReceta,
          idAfiliadoExterno: props.idObraSocial === OBRAS_SOCIALES.OSPEDYC ? null : afiliadoSeleccionado?.id_afiliado,
          tratamientoProlongado,
          duplicada
        };

        dispatch(setReceta(data));
        dispatch(postReceta(data, setShowForm, null, recetaSeleccionada === null));
      }
    }
  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
        <Grid
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "center" }}
        >

          <Grid item xs={6}>
            {Array.isArray(tipoRecetasDigitales) && tipoRecetasDigitales.length > 0 && (
              <SelectValidator
                fullWidth
                margin="normal"
                label="Tipo de Receta"
                name="idTipo"
                value={idTipoReceta}
                onChange={(e) => {
                  setearValor("idTipoReceta", e.target.value);
                }}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {tipoRecetasDigitales.map((TipoReceta) => (
                  <MenuItem
                    key={TipoReceta.idTipo}
                    value={TipoReceta.idTipo}
                  >
                    {TipoReceta.descripcion}
                  </MenuItem>
                ))}
              </SelectValidator>
            )}
          </Grid>
          {Array.isArray(subtipoRecetasDigitales) && subtipoRecetasDigitales.length > 0
            && idTipoReceta === TIPOS_RECETAS.PRESCRIPCION
            && (
              <Grid item xs={6}>
                <SelectValidator
                  fullWidth
                  margin="normal"
                  label="Subtipo de Receta"
                  name="idSubtipo"
                  value={idSubtipoReceta}
                  onChange={(e) => {
                    setearValor("idSubtipoReceta", e.target.value);
                  }}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                >
                  {subtipoRecetasDigitales.map((SubtipoReceta) => (
                    <MenuItem
                      key={SubtipoReceta.idSubtipo}
                      value={SubtipoReceta.idSubtipo}
                    >
                      {SubtipoReceta.descripcion}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>)}
          <Grid
            container
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={12} md={4} >
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  margin="normal"
                  id="dialogFecFin"
                  label="Fecha"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={false}
                  value={fecha}
                  onChange={(date) => {
                    setearValor("fecha", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                  minDate={new Date()}
                  minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            style={{ display: "flex", justifyContent: "center", marginLeft: "40px" }}
          >
            {idTipoReceta === TIPOS_RECETAS.RECETA && 
            <Grid item xs={12} md={3} >
              <FormControlLabel
                control={
                  <Checkbox
                    name="duplicada"
                    disabled={false}
                    checked={duplicada}
                    onChange={(e) => {
                      setearValor("duplicada", e.target.checked);
                    }}
                  />
                }
                label="Duplicada"
              />
            </Grid>}
            <Grid item xs={12} md={4} >
              <FormControlLabel
                control={
                  <Checkbox
                    name="tratamientoProlongado"
                    disabled={false}
                    checked={tratamientoProlongado}
                    onChange={(e) => {
                      setearValor("tratamientoProlongado", e.target.checked);
                    }}
                  />
                }
                label="Tratamiento Prolongado"
              />
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStep(STEPPER_RECETAS.DATOS_TITULAR));
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
      {openModalAlertaFecha && (
        <ModalAlertaFecha
          open={openModalAlertaFecha}
          close={() => {
            setOpenModalAlertaFecha(false);
          }}
          idRecetaDigital={recetaSeleccionada.idRecetaDigital}
          avanzarReceta={onSubmitHandler}
          idAfiliado={afiliadoSeleccionado?.id_afiliado}
          idTipoReceta={idTipoReceta}
          fecha={fecha}
        />
      )}
    </React.Fragment>
  );
};
